import '@oy/uicore/src/css/fortune.css';
import { createRoot } from 'react-dom/client';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import 'react-multi-carousel/lib/styles.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { defaultLocale } from 'src/utilities/Yup';
import * as yup from 'yup';
import App from './App';
import './assets/scss/index.scss';
import {
  initGtm,
  initSentry,
  registerAnalytics,
} from './constants/ModuleConfigs';

import { ThemeProvider } from './components/ThemeProvider/ThemeProvider';
import { IS_WHITELABELING } from './constants';
import { persistor, store } from './redux/storeConfig/store';
import * as serviceWorker from './serviceWorker';
import './styles/brand.css';
import axiosInterceptors from './utilities/Network/interceptors';
import { initTranslation } from './utilities/translator';

// Set localization
initTranslation();
yup.setLocale(defaultLocale);

// Initialize 3rd party config
if (!IS_WHITELABELING) {
  registerAnalytics();
  initSentry();
  initGtm();
}

// Network Setup
axiosInterceptors.setup(store);

// Initialize Root
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);

// Init
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </ThemeProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
